'use client';
import React, { useEffect, useState } from 'react';

// Components Imports
import { clearHistory } from '@/app/(db)/actions';
import { ClearHistory } from '@/components/generic/clear-history';
import { FooterText } from '@/components/generic/footer'
import { SidebarItems } from '@/components/generic/sidebar-items';

// Styles and Globals
import "@/app/globals.css";

interface SidebarListProps {
  userId?: string;
  children?: React.ReactNode;
}

async function fetchHistory(userId?: string, limit: number = 200) {
  const start = performance.now();
  let url = `/api/requests_history?limit=${limit}`;
  if (userId) {
    url += `&userId=${encodeURIComponent(userId)}`;
  }
  const res = await fetch(url);
  const data = await res.json();
  const end = performance.now();
  console.log('SidebarList fetchHistory time:', end - start, 'ms');
  return data;
}

function SidebarFooter({ clearEnabled }: { clearEnabled: boolean }) {
  return (
    <div className="flex-none p-2 flex flex-col items-center gap-2">
      <div className="flex w-full items-center justify-between">
        <ClearHistory clearHistory={clearHistory} isEnabled={clearEnabled} />
      </div>
      <FooterText />
    </div>
  );
}

export function SidebarList({ userId }: SidebarListProps) {
  const [history, setHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    const timeout = setTimeout(() => {
      if (mounted) setLoading(false);
    }, 60000);
    fetchHistory(userId).then(data => {
      if (mounted) {
        setHistory(data);
        setLoading(false);
      }
    });
    return () => { mounted = false; clearTimeout(timeout); };
  }, [userId]);

  if (loading) {
    return (
      <div className="flex flex-col max-h-[75%] h-full justify-between">
        <div className="p-8 text-center text-muted-foreground flex flex-col items-center gap-2">
          <svg className="animate-spin h-5 w-5 text-aw-text-muted mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
            <circle className="opacity-25" cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="3"></circle>
            <path className="opacity-75" fill="currentColor" d="M2 8a6 6 0 016-6v2a4 4 0 00-4 4H2z"></path>
          </svg>
          Loading request history...
        </div>
        <SidebarFooter clearEnabled={false} />
      </div>
    );
  }

  if (!Array.isArray(history)) {
    return <div className="p-8 text-center text-aw-error">Failed to load history</div>;
  }

  return (
    <div className="flex flex-col max-h-[75%]">
      <div className="flex flex-col gap-2 overflow-y-scroll max-h-[75%]">
        {history.length ? (
          <div className="space-y-2 px-2">
            <SidebarItems chats={history} />
          </div>
        ) : (
          <div className="p-8 text-center">
            <p className="text-sm text-muted-foreground">No history</p>
          </div>
        )}
      </div>
      <SidebarFooter clearEnabled={history.length > 0} />
    </div>
  );
}